import React from "react";
import DelegationSelection from "./DelegationSelection";
import ViewDelegation from "../TaskPod/ViewDelegation";
import { ReactComponent as AddProfileWithCircle } from "../../assets/images/addProfileWithCircle.svg";
import { ReactComponent as AssignedToBlueIcon } from "../../assets/images/assignedToBlue.svg";

const DelegationComponent = ({
  handleMouseLeave,
  handleCheck,
  formData,
  personTableData,
  handleSelectPerson,
  searchTerm,
  isFormDisabled,
  isEditTask,
  taskassignedtoref,
  handleMouseEnter,
  isSearchBarOpen,
  depth = "D0",
  personCountAllowed,
}) => {
  return (
    <div className="pl-1 flex">
      <div className="relative">
        <button
          type="button"
          onClick={(event) => {
            taskassignedtoref.current = event.target;
            handleMouseEnter(depth);
          }}
          ref={taskassignedtoref}
          disabled={isFormDisabled}
          //disabled={isFormDisabled}
          style={{ opacity: isFormDisabled ? 0.5 : 1 }}
        >
          <AssignedToBlueIcon />
        </button>

        {isSearchBarOpen[depth] && (
          <DelegationSelection
            depth={depth}
            handleMouseLeave={handleMouseLeave}
            handleCheck={handleCheck}
            formData={formData}
            personTableData={personTableData}
            handleSelectPerson={handleSelectPerson}
            searchTerm={searchTerm}
            personCountAllowed={personCountAllowed}
          />
        )}
      </div>
      <ViewDelegation
        isFormDisabled={isFormDisabled}
        isEditTask={isEditTask}
        taskassignedtoref={taskassignedtoref}
        handleMouseEnter={handleMouseEnter}
        formData={formData}
        depth={depth}
      />
    </div>
  );
};

export default DelegationComponent;
